<template>
  <div class="workshop-enroll">
    <!-- <img class="workshop-enroll-bg" src="https://jc-1300322797.cos.ap-shanghai.myqcloud.com/static/extra/site-images/activity/workshop-enroll/kangzhong-app.png"> -->
    <img class="workshop-enroll-bg" :src="$getImgUrl('/site-images/activity/workshop-enroll/kangzhong-app.png')">
    <img class="immediatelyEnroll" src="../../assets/images/activity/workshop/immediatelyEnroll.png" @click="toEnprll">

  </div>
</template>

<script>
// import activityApi from '../../api/activity'
import { userUtils } from '@/utils/auth'
import { commonUtils } from '@/utils/common'

export default {
  components: {
  },
  data () {
    return {
    }
  },

  computed: {
  },

  created () {
    if (this.$route.query.from) {
      sessionStorage.setItem('fromSource', this.$route.query.from)
      this.fromSource = this.$route.query.from
    } else {
      this.fromSource = sessionStorage.getItem('fromSource')
    }
    this.clientInfo = userUtils.getClientInfo()
    // if (!this.clientInfo) {
    //   window.location.href = commonUtils.getExtraSite() + '/#/login'
    // }
    commonUtils.reportViewTrace('activityCode')
  },
  methods: {
    // 跳转
    toEnprll () {
      console.log(this.fromSource)
      // this.$router.push({ path: '/activity/live-broadcast-register', query: { activityCode: this.$route.query.activityCode || '' } })
      this.$router.push({ name: 'activity-workshop-goLogin', query: { fromSource: this.fromSource } })
    }
  }
}
</script>

<style lang="less" scoped>
.workshop-enroll {
  position: relative;
}

.workshop-enroll .workshop-enroll-bg{
  width: 375px;
  height: auto;
}
.workshop-enroll .immediatelyEnroll{
  position: absolute;
  width: 140px;
  height: auto;
  top: 660px;
  left: 50%;
  margin-left: -70px;
  animation:mymove 3s infinite;
  animation-direction:alternate;          /*轮流反向播放动画。*/
  animation-timing-function: ease-in-out; /*动画的速度曲线*/
}
@keyframes mymove {
    0%{
        transform: scale(1);  /*开始为原始大小*/
    }
    25%{
        transform: scale(1.1); /*放大1.1倍*/
    }
    50%{
        transform: scale(1);
    }
    75%{
        transform: scale(1.1);
    }
}
</style>
